<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 15%; position: relative;">
                            <h1 class="font-general-sans text-center custom-54px-400" data-aos="fade-left">
                                Unlock Your Potential with Interviewrr:
                            </h1>
                            <h3 class="custom-54px-600 font-general-sans text-center" data-aos="fade-right">Your Gateway to Interview Success</h3>
                            <div class="responsive-card">
                                <CCard class="border-radius-16px p-4" data-aos="zoom-in">
                                    <img src="../assets/img/Input.png" style="max-width: 100%;" class="" />
                                    <h3 class="ccustom-18xp-500 text-black font-general-sans text-center mt-4">Prepare Your Interview with Us</h3>
                                    <p class="custom-14px-500 font-color-AEAEB2 text-center">Record Yourself and Check in Real Time</p>
                                    <span class="border-radius-24px font-general-sans text-center" @click="GotoHowItWork()">Start</span>
                                </CCard>
                            </div>
    
                            <label class="bottom-right-button-text"><strong><b>Are you a company looking for talent?</b></strong></label>
                            <br />
                            <button class="bottom-right-button" @click="OpenCalendly()"><label class="custom-16px-700 text-white">Book a Tour</label>
                                <br />
                               <label class="custom-12px-700 text-white">Powered by Calendly</label> </button>
    
    
    
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white">
            <CCol sm="12" class="responsive-90">
                <div class="text-center">
                    <CRow>
                        <CCol sm="6">
                            <h3 class="custom-48px-600 text-left mt-3" data-aos="zoom-in"> Our proprietary AI <br />Technology Analyzes <br />Interview Responses </h3>
                        </CCol>
                        <CCol sm="6">
                            <p class="custom-18xp-400 text-left font-general-sans font-color-696969 mt-5" data-aos="zoom-out">Welcome to Interviewrr, where we're revolutionizing the interview experience through cutting-edge AI technology. Our mission is to empower job seekers to excel in their interviews and land their dream jobs with confidence.</p>
                            <CRow>
                                <CCol sm="12" class="text-left">
                                    <CRow>
                                        <CCol sm="8"><label class="custom-border-purple p-2 text-left mr-2" @click="OpenHowItWork()">Learn More</label><img src="../assets/img/arrow-right.png" style="width:30px" class="ml-5" @click="GoToLogin()" /><label class="font-color-696969 ml-2"
                                                @click="GoToLogin()">Sign up</label></CCol>
                                        <CCol sm="4"></CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
    
                        </CCol>
    
                        <CCol sm="12 mt-3">
                            <div class="image-container">
                                <img src="../assets/img/bannerPeople.png" alt="Background Image" class="background-image" />
                                <div class="overlay-text">
                                    <h3 class="custom-24px-400"></h3> Interviewrr.ai shortens the traditional interview process, enabling faster <br />decisions with visual assessments and unbiased AI-driven character analysis.
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                </div>
            </CCol>
            <br /><br /><br />
        </CCol>
    
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" class="responsive-90">
                <div class="text-center">
                    <br /><br /><br />
                    <CRow>
                        <CCol sm="6">
                            <h1 class="custom-48px-600 text-left mt-3" data-aos="fade-down">
                                Premier destination for revolutionizing the interview process
                            </h1>
                            <p class="custom-18xp-400 text-left font-general-sans font-color-696969 mt-2" data-aos="fade-down">Powered by state-of-the-art AI technology, we're dedicated to helping job seekers hone their interview skills and secure their ideal positions with confidence.</p>
                            <CRow>
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconmentol.png" style="width:20px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="fade-down">
                                            Innovation
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="fade-down">
                                            We're committed to pushing the boundaries of technology to create innovative solutions that empower job seekers.
                                        </p>
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconlight.png" style="width:20px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="fade-down">
                                            Empowerment
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="fade-down">
                                            We believe in providing individuals with the tools and resources they need to succeed in their professional endeavors. </p>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="6">
                            <img style="max-width:420px" src="../assets/img/mentol.png" class="mt-3 d-sm-down-none" data-aos="zoom-out" />
                            <img style="max-width:100%" src="../assets/img/mentol.png" class="mt-3 d-md-none" data-aos="zoom-out" />
                        </CCol>
                    </CRow>
    
                </div>
            </CCol>
    
    
        </CCol>
    
        <CCol sm="12" class="bg-white">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" class="responsive-90">
                        <div class="text-center">
                            <br /><br /><br />
                            <h1 class="custom-text-aladdin text-black poppin-font text-48px" data-aos="slide-up">
                                Our Features
                            </h1>
                            <p class="custom-16px-400 text-center ml-4" data-aos="zoom-out">Get to know the talented individuals driving our company forward.</p>
    
                            <br />
    
                            <CRow style="margin-left:3%;margin-right:3%" class="d-sm-down-none">
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F1.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Auto Transcribe to Any Language to English
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Enjoy the convenience of understanding conversations with our automatic transcription feature. We convert interview recordings from any language into English quickly and accurately, making it easier for you to analyze and compare candidates. </p>
    
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Playback of the Video Interview to Confirm Visual Appearance
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Allows candidates to review their video interviews after completion, focusing on their visual appearance. With this feature, candidates can verify appearance, adjust accordingly, enhance preparedness, and get feedback.</p>
    
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F2.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F3.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Evaluation of Body Language
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        On our AI-powered platform is a tool that utilizes AI technology to provide valuable insights into candidates' nonverbal communication patterns. It enables recruiters to make more informed hiring decisions, while saving time and resources through automated
                                        analysis processes.</p>
    
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Benefactor for the Company
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Represents a highly valuable investment for companies looking to enhance efficiency and effectiveness in the recruitment process. The primary benefits of this feature include rapid screening and assessment, access to pre-screened candidate database, and
                                        reduction in time and costs.</p>
    
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F5.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F6.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <br /><br /><br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        AI-driven character analysis
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Interviewrr.ai performs AI-driven character analysis by evaluating verbal and non-verbal cues from video interviews, creating comprehensive candidate profiles based on advanced language models and pattern recognition.</p>
    
                                </CCol>
    
    
    
    
    
    
    
    
                            </CRow>
    
                            <CRow class="d-md-none">
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F1.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Auto Transcribe to Any Language to English
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Enjoy the convenience of understanding conversations with our automatic transcription feature. We convert interview recordings from any language into English quickly and accurately, making it easier for you to analyze and compare candidates. </p>
    
                                </CCol>
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Playback of the Video Interview to Confirm Visual Appearance
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Allows candidates to review their video interviews after completion, focusing on their visual appearance. With this feature, candidates can verify appearance, adjust accordingly, enhance preparedness, and get feedback.</p>
    
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F2.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F3.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Evaluation of Body Language
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        On our AI-powered platform is a tool that utilizes AI technology to provide valuable insights into candidates' nonverbal communication patterns. It enables recruiters to make more informed hiring decisions, while saving time and resources through automated
                                        analysis processes.</p>
    
                                </CCol>
    
                                <CCol sm="6">
                                    <br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        Benefactor for the Company
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Represents a highly valuable investment for companies looking to enhance efficiency and effectiveness in the recruitment process. The primary benefits of this feature include rapid screening and assessment, access to pre-screened candidate database, and
                                        reduction in time and costs.</p>
    
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F5.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/F6.png" style="max-width:100%" class="m-4 b-20" />
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="6">
                                    <br /><br /><br />
                                    <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                                        AI-driven character analysis
                                    </h3>
                                    <p class="custom-16px-400 text-left" data-aos="zoom-out">
                                        Interviewrr.ai performs AI-driven character analysis by evaluating verbal and non-verbal cues from video interviews, creating comprehensive candidate profiles based on advanced language models and pattern recognition.</p>
    
                                </CCol>
                            </CRow>
                        </div>
                    </CCol>
                </div>
            </CCol>
    
        </CCol>
    
    
        <CCol sm="12" class="bg-F5F5F5">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" class="responsive-90">
                        <div class="text-center">
                            <br /><br /><br />
                            <h1 class="custom-text-aladdin text-black poppin-font text-48px" data-aos="slide-up">
                                How It Works
                            </h1>
                            <p class="custom-16px-400 text-center ml-4" data-aos="zoom-out">Get to know the talented individuals driving our company forward.</p>
    
                            <br />
                            <CRow style="margin-left:3%;margin-right:3%" class="d-sm-down-none">
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconcamera.png" style="width:30px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="zoom-in">
                                            Record
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="zoom-out">
                                            Self-recording to answer instant questions on the Interviewrr portal and get expert feedback through the email/portal.</p>
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconai.png" style="width:30px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="zoom-in">
                                            AI Review
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="zoom-out">
                                            Our AI-powered platform offers top-notch feedback, along with exclusive insights from industry experts. </p>
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconrefine.png" style="width:30px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="zoom-in">
                                            Refinement
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="zoom-out">
                                            Tailored feedback to enhance user resume and increase their chances of <br />landing a job.</p>
                                    </CCard>
                                </CCol>
                            </CRow>
    
                            <CRow class="d-md-none">
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconcamera.png" style="width:30px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="zoom-in">
                                            Upload
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="zoom-out">
                                            Self-recording to answer instant questions on the Interviewrr portal and get expert feedback through the email/portal.</p>
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconai.png" style="width:30px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="zoom-in">
                                            AI Review
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="zoom-out">
                                            Our AI-powered platform offers top-notch feedback, along with exclusive insights from industry experts. </p>
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconrefine.png" style="width:30px" class="m-4" />
                                        <h3 class="custom-24px-500 text-left ml-4" data-aos="zoom-in">
                                            Refinement
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4" data-aos="zoom-out">
                                            Tailored feedback to enhance user resume and increase their chances of <br />landing a job.</p>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </div>
    
                    </CCol>
                </div>
            </CCol>
        </CCol>
    
    
    
        <CCol sm="12" class="bg-F5F5F5">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" class="responsive-90">
                        <div class="text-center">
                            <br /><br /><br />
    
                            <h1 class="custom-40px-600" data-aos="fade-left">
                                AI-Conducted Interviews Benefited these <br /> job seekers and more than <span class="font-color-615FCD">33,000</span> others
                            </h1>
                            <p class="custom-16px-400 text-center ml-4" data-aos="fade-right">You’re a mock interview away from your dream job.</p>
                            <CRow class="m-0">
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "AI interview technology was a game-changer for me. As a recent graduate, I struggled to get noticed by employers."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A1.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">John D</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "The AI interview process was incredibly thorough and fair. It evaluated my responses, body language, and even my..."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A2.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Emma W</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "It has significantly improved our ability to identify the right candidates by providing consistent, unbiased assessments”
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A3.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Jason T</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
    
                                </CCol>
    
    
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "It has greatly improved our ability to find the right candidates quickly and accurately. The AI provides consistent.."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A4.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Maria S.</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "The AI provides consistent, unbiased evaluations, ensuring we find individuals who truly fit our requirements."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A5.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Michael T</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4" class="p-0">
                                    <CCard class="border-12px m-2" style="border:none">
                                        <h4 class="custom-18px-400 p-20 text-left">
                                            "The AI interview was a unique and enlightening experience. It highlighted aspects of my performance that I hadn't.."
                                        </h4>
                                        <CCol sm="12" class="p-0">
                                            <hr />
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="4">
                                                    <img style="max-width:100%" src="../assets/img/A6.png" />
                                                </CCol>
                                                <CCol sm="8" class="text-left">
                                                    <label class="custom-16px-500">Sophia R</label>
                                                    <br />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                    <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
                                    </CCard>
    
                                </CCol>
    
                            </CRow>
                        </div>
                    </CCol>
    
                </div>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;" class="d-sm-down-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                            Sign up now for free and take the first step toward landing your dream job!
                                                                                            </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
    
                    <CCol sm="12" style="width: 100%;margin: auto;" class="d-md-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                            Sign up now for free and take the <br /> first step toward landing your dream job!
                                                                                            </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
    
        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all">
            <div class="popup-all2">
                <!-- Popup content -->
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/interest.png" />
                    <h3 class="custom-32px-500">Register Your Interest!</h3>
                    <h3 class="custom-16px-400 text-center">Dear User, currently our slots for this feature are fully occupied. If you want this feature to assist you, please register. If slots become available, we will notify you via email</h3>
    
                    <h3 class="custom-14px-500 mt-4 text-left">Add Me To The List</h3>
                    <input type="text" v-model="emailinterest" class="custom-input-app" placeholder="test@gmail.com" />
                </div>
                <div class="text-center mt-4">
                    <span class="custom-border-purple p-2 text-center text-white pr-2 pl-2" @click="OpenPopup()">Submit</span>
                </div>
            </div>
        </div>
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <!-- <div :class="popupClass"> -->
                <div class="popup-all1">
                    <div class="text-right">
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" class="text-right" />
            </div>
                <CTabs v-model="activetab" variant="pills" class="custom-tabs">
                    <CTab title="Record Interview" name="Career" @click="setActiveTab('Career')" class="custom-tab">
                       <div class="custom-scroll">
      <div style="width: 80%;background-size: cover; margin: auto;">
        <div class="m-0">
                            <div class="text-center">
                                <h3 class="custom-16px-500 mt-1 text-center mt-3">Career Path Selection</h3>
                                <h3 class="custom-16px-400 text-center">Help tailor the interview questions and feedback to your specific career goals and aspirations</h3>
                                <h3 class="custom-14px-500 mt-1 text-left">Your current field Of Expertise</h3>
                                <v-select v-model="selectedPosition" :options="positionOptions" label="Name"></v-select>
    
                                <h3 class="custom-14px-500 mt-1 text-left">Field For the Interview</h3>
                                <v-select v-model="selectedPosition1" :options="positionOptions" label="Name"></v-select>
                                <h3 class="custom-16px-400 text-left">which can be the same or different from your current field</h3>

                                <h3 class="custom-14px-500 text-left">Company Code</h3>
                                <h3 class="custom-16px-400 text-left"><input type="checkbox" class="mr-2" v-model="companyCode"/>if you have code from company that request for personal video interview</h3>
                                <div v-if="this.ErrorPosition == true" class="mt-1">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error: Please fill in the form position</strong>
                                                </CAlert>
                                            </div>

                                
                                <div v-if="this.ErrorCode == true" class="mt-1">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2"></strong> {{ Message }} Please try insert new code.
                                                </CAlert>
                                            </div>

                                            <div v-if="this.ShowCode == true" class="mt-1">
                                                <CAlert show color="success">
                                                    <strong class="text-danger mr-2"></strong> {{ Message }}
                                                </CAlert>
                                            </div>
                            </div>
                                <div v-if="companyCode">
                                    <CAlert color="danger" class="mb-2" v-if="codeCompany === ''">Note : Please input your code</CAlert>
        <div class="input-container">
    <CInput type="text" v-model="codeCompany" class="custom" placeholder="Enter code..."/>
    <CButton type="button" class="verify-button" @click="VerifyCodeData()">Verify</CButton>
  </div>
</div>
 
                            <!-- <div class="text-center mt-2">
                                <span
        class="custom-border-purple p-2 text-center text-white pr-2 pl-2"
        :class="{ 'disabled': ErrorCode }"
        @click="ErrorCode ? null : OpenFormVideo()"
    >
        Submit
    </span>
                            </div> -->

                            <div class="text-center mt-2">
                                <span
        class="custom-border-purple p-2 text-center text-white pr-2 pl-2"
        @click="OpenFormVideo()"
    >
        Submit
    </span>
                            </div>
                        </div>
                    </div>
                        </div>
                    </CTab>
                    <!-- <CTab title="Job Opportunity" name="Job" @click="setActiveTab('Job')" class="custom-tab">
                      
                        <div class="custom-scroll">
                            <CRow class="mt-5">
                                <CCol sm="2">
                                    <input type="text" class="custom-input-app p-20" style="height:20px;padding:18px" placeholder="Location.." />
                                </CCol>
                                <CCol sm="7">
                                    <input type="text" class="custom-input-app p-20" style="height:20px;padding:18px" placeholder="Search for job..." />
                                </CCol>
                                <CCol sm="1" class="p-0">
                                    <CButton class="custom-border-grey-white b-20 font-color-696969 d-flex" @click="OpenFilter()"><img src="../assets/img/Filter.png" style="width:20px" />Filter</CButton>
                                </CCol>
    
                                <CCol sm="1">
                                    <CButton class="custom-border-purple text-white">Search</CButton>
                                </CCol>
                                <CCol sm="12">
                                <div v-if="hideColumn">
                                    <CRow>
                                        <CCol sm="12">
                                            <label class="custom-14px-500 font-color-928AFD mt-3 mb-3">2</label> <span class="font-color-696969">jobs found</span>
                                        </CCol>
                                      
                                        <CCol sm="6">
                                           
                                            <CCard class="border-16px">
                                                <div class="m-3">
                                                    <CRow>
                                                        <CCol sm="10">
                                                            <img src="../assets/img/Google-icon.png" style="max-width:32px" />
                                                        </CCol>
                                                        <CCol sm="2">
                                                            <img v-if="isLoved" src="../assets/img/love-red.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                            <img v-else src="../assets/img/love-white.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                        </CCol>
                                                        <CCol sm="12" class="mt-3">
                                                            <label class="custom-18px-600">
                                Sr. UI/UX Designer
                              </label>
                                                            <br />
                                                            <label class="custom-14px-500 font-color-928AFD mt-1">Figma</label>
                                                            <br /><br />
                                                            <CRow>
                                                                <CCol sm="6">
                                                                    <img src="../assets/img/icon-user.png" style="max-width:20px" />
                                                                    <label class="custom-14px-500 font-color-696969 ml-3">1-3 year</label>
                                                                </CCol>
    
                                                                <CCol sm="6">
                                                                    <img src="../assets/img/timer.png" style="max-width:20px" />
                                                                    <label class="custom-14px-500 font-color-696969 ml-3">Remote</label>
                                                                </CCol>
    
                                                                <CCol sm="12">
                                                                    <img src="../assets/img/location 2.png" style="max-width:20px" />
                                                                    <label class="custom-14px-500 font-color-696969 ml-3">Johor</label>
                                                                    <br />
                                                                    <label class="custom-14px-400 font-color-696969">
                                    This position is for a Senior UI/UX Designer who collaborates with cross-functional teams, creates user-centered designs, and conducts usability testing. This role is ideal for someone who enjoys shaping digital experiences with a focus on user needs.
                                  </label>
                                                                    <br /><br />
                                                                    <span class="custom-light-purple font-color-928AFD border-radius-half mr-2">Web Design</span>
                                                                    <span class="custom-light-purple font-color-928AFD border-radius-half">App Design</span>
                                                                    <CRow class="mt-3">
                                                                        <CCol sm="5">
                                                                            <label class="custom-20px-600">$1K</label> <span class="font-color-696969">/ years</span>
                                                                        </CCol>
                                                                        <CCol sm="7">
                                                                            <label class="custom-14px-500 font-color-928AFD mt-1">10 hours ago</label>
                                                                            <label class="font-color-696969 ml-2">120 applicants</label>
                                                                        </CCol>
                                                                    </CRow>
                                                                </CCol>
                                                            </CRow>
                                                        </CCol>
                                                    </CRow>
                                                </div>
                                            </CCard>
                                        </CCol>
    
                                        <CCol sm="6">
                                             <CCard class="border-16px">
                                                <div class="m-3">
                                                    <CRow>
                                                        <CCol sm="10">
                                                            <img src="../assets/img/Google-icon.png" style="max-width:32px" />
                                                        </CCol>
                                                        <CCol sm="2">
                                                            <img v-if="isLoved" src="../assets/img/love-red.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                            <img v-else src="../assets/img/love-white.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                        </CCol>
                                                        <CCol sm="12" class="mt-3">
                                                            <label class="custom-18px-600">
                                Sr. UI/UX Designer
                              </label>
                                                            <br />
                                                            <label class="custom-14px-500 font-color-928AFD mt-1">Figma</label>
                                                            <br /><br />
                                                            <CRow>
                                                                <CCol sm="6">
                                                                    <img src="../assets/img/icon-user.png" style="max-width:20px" />
                                                                    <label class="custom-14px-500 font-color-696969 ml-3">1-3 year</label>
                                                                </CCol>
    
                                                                <CCol sm="6">
                                                                    <img src="../assets/img/timer.png" style="max-width:20px" />
                                                                    <label class="custom-14px-500 font-color-696969 ml-3">Remote</label>
                                                                </CCol>
    
                                                                <CCol sm="12">
                                                                    <img src="../assets/img/location 2.png" style="max-width:20px" />
                                                                    <label class="custom-14px-500 font-color-696969 ml-3">Johor</label>
                                                                    <br />
                                                                    <label class="custom-14px-400 font-color-696969">
                                    This position is for a Senior UI/UX Designer who collaborates with cross-functional teams, creates user-centered designs, and conducts usability testing. This role is ideal for someone who enjoys shaping digital experiences with a focus on user needs.
                                  </label>
                                                                    <br /><br />
                                                                    <span class="custom-light-purple font-color-928AFD border-radius-half mr-2">Web Design</span>
                                                                    <span class="custom-light-purple font-color-928AFD border-radius-half">App Design</span>
                                                                    <CRow class="mt-3">
                                                                        <CCol sm="5">
                                                                            <label class="custom-20px-600">$1K</label> <span class="font-color-696969">/ years</span>
                                                                        </CCol>
                                                                        <CCol sm="7">
                                                                            <label class="custom-14px-500 font-color-928AFD mt-1">10 hours ago</label>
                                                                            <label class="font-color-696969 ml-2">120 applicants</label>
                                                                        </CCol>
                                                                    </CRow>
                                                                </CCol>
                                                            </CRow>
                                                        </CCol>
                                                    </CRow>
                                                </div>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCol>
                            </CRow>
                            <div v-if="filter">
                                <CRow class="mt-2">
                                    <CCol sm="12">
                                            <label class="custom-14px-500 font-color-928AFD mt-3 mb-3">2</label> <span class="font-color-696969">jobs found</span>
                                        </CCol>
                                    <CCol sm="4">
                                         <CCard class="border-16px">
                                            <div class="m-3">
                                                <CRow>
                                                    <CCol sm="9">
                                                        <img src="../assets/img/Google-icon.png" style="max-width:32px" />
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <img v-if="isLoved" src="../assets/img/love-red.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                        <img v-else src="../assets/img/love-white.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                    </CCol>
                                                    <CCol sm="12" class="mt-3">
                                                        <label class="custom-18px-600">
                                Sr. UI/UX Designer
                              </label>
                                                        <br />
                                                        <label class="custom-14px-500 font-color-928AFD mt-1">Figma</label>
                                                        <br /><br />
                                                        <CRow>
                                                            <CCol sm="6">
                                                                <img src="../assets/img/icon-user.png" style="max-width:20px" />
                                                                <label class="custom-14px-500 font-color-696969 ml-3">1-3 year</label>
                                                            </CCol>
    
                                                            <CCol sm="6">
                                                                <img src="../assets/img/timer.png" style="max-width:20px" />
                                                                <label class="custom-14px-500 font-color-696969 ml-3">Remote</label>
                                                            </CCol>
    
                                                            <CCol sm="12">
                                                                <img src="../assets/img/location 2.png" style="max-width:20px" />
                                                                <label class="custom-14px-500 font-color-696969 ml-3">Johor</label>
                                                                <br />
                                                                <label class="custom-14px-400 font-color-696969">
                                    This position is for a Senior UI/UX Designer who collaborates with cross-functional teams, creates user-centered designs, and conducts usability testing. This role is ideal for someone who enjoys shaping digital experiences with a focus on user needs.
                                  </label>
                                                                <br /><br />
                                                                <span class="custom-light-purple font-color-928AFD border-radius-half mr-2">Web Design</span>
                                                                <span class="custom-light-purple font-color-928AFD border-radius-half">App Design</span>
                                                                <CRow class="mt-3">
                                                                    <CCol sm="5">
                                                                        <label class="custom-20px-600">$1K</label> <span class="font-color-696969">/ years</span>
                                                                    </CCol>
                                                                    <CCol sm="7">
                                                                        <label class="custom-14px-500 font-color-928AFD mt-1">10 hours ago</label>
                                                                        <label class="font-color-696969 ml-2">120 applicants</label>
                                                                    </CCol>
                                                                </CRow>
                                                            </CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CRow>
                                            </div>
                                        </CCard>
                                    </CCol>
    
                                    <CCol sm="4"> <CCard class="border-16px">
                                            <div class="m-3">
                                                <CRow>
                                                    <CCol sm="9">
                                                        <img src="../assets/img/Google-icon.png" style="max-width:32px" />
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <img v-if="isLoved" src="../assets/img/love-red.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                        <img v-else src="../assets/img/love-white.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                    </CCol>
                                                    <CCol sm="12" class="mt-3">
                                                        <label class="custom-18px-600">
                                Sr. UI/UX Designer
                              </label>
                                                        <br />
                                                        <label class="custom-14px-500 font-color-928AFD mt-1">Figma</label>
                                                        <br /><br />
                                                        <CRow>
                                                            <CCol sm="6">
                                                                <img src="../assets/img/icon-user.png" style="max-width:20px" />
                                                                <label class="custom-14px-500 font-color-696969 ml-3">1-3 year</label>
                                                            </CCol>
    
                                                            <CCol sm="6">
                                                                <img src="../assets/img/timer.png" style="max-width:20px" />
                                                                <label class="custom-14px-500 font-color-696969 ml-3">Remote</label>
                                                            </CCol>
    
                                                            <CCol sm="12">
                                                                <img src="../assets/img/location 2.png" style="max-width:20px" />
                                                                <label class="custom-14px-500 font-color-696969 ml-3">Johor</label>
                                                                <br />
                                                                <label class="custom-14px-400 font-color-696969">
                                    This position is for a Senior UI/UX Designer who collaborates with cross-functional teams, creates user-centered designs, and conducts usability testing. This role is ideal for someone who enjoys shaping digital experiences with a focus on user needs.
                                  </label>
                                                                <br /><br />
                                                                <span class="custom-light-purple font-color-928AFD border-radius-half mr-2">Web Design</span>
                                                                <span class="custom-light-purple font-color-928AFD border-radius-half">App Design</span>
                                                                <CRow class="mt-3">
                                                                    <CCol sm="5">
                                                                        <label class="custom-20px-600">$1K</label> <span class="font-color-696969">/ years</span>
                                                                    </CCol>
                                                                    <CCol sm="7">
                                                                        <label class="custom-14px-500 font-color-928AFD mt-1">10 hours ago</label>
                                                                        <label class="font-color-696969 ml-2">120 applicants</label>
                                                                    </CCol>
                                                                </CRow>
                                                            </CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CRow>
                                            </div>
                                        </CCard>
                                    </CCol>
                                    <CCol sm="4">
                                            <div class="p-2 ml-2">
                                                <label class="custom-16px-600 ml-2">Filter by</label>
                                                <br />
                                                <div>
                                                    <div class="custom-14px-500 ml-2 mt-2 font-color-171717" @click="toggleCategoryList">
    
    
                                                        <CRow class="mb-2">
                                                            <CCol sm="10">Category</CCol>
                                                            <CCol sm="2">
                                                                <span v-if="isCategoryListVisible"><img src="../assets/img/arrowup-black.png" style="max-width:20px"/></span>
                                                                <span v-else><img src="../assets/img/arrowdown-black.png" style="max-width:20px"/></span>
                                                            </CCol>
    
                                                        </CRow>
    
                                                    </div>
                                                    <div v-if="isCategoryListVisible">
                                                        <CRow v-for="item in categoryJob" :key="item.Id" class="m-1">
                                                            <CCol sm="2">
                                                                <input type="checkbox" />
                                                            </CCol>
                                                            <CCol sm="10">
                                                                <label class="font-color-171717">{{ item.Category }}</label>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </div>
    
    
                                                <div>
                                                    <div class="custom-14px-500 ml-2 mt-2 font-color-171717" @click="toggleTypeList">
    
    
                                                        <CRow class="mb-2">
                                                            <CCol sm="10">Job Type</CCol>
                                                            <CCol sm="2">
                                                                <span v-if="isTypeListVisible"><img src="../assets/img/arrowup-black.png" style="max-width:20px"/></span>
                                                                <span v-else><img src="../assets/img/arrowdown-black.png" style="max-width:20px"/></span>
                                                            </CCol>
    
                                                        </CRow>
    
                                                    </div>
                                                    <div v-if="isTypeListVisible">
                                                        <CRow v-for="item in categoryJobType" :key="item.Id" class="m-1">
                                                            <CCol sm="2">
                                                                <input type="checkbox" />
                                                            </CCol>
                                                            <CCol sm="10">
                                                                <label class="font-color-171717">{{ item.Category }}</label>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </div>
    
    
                                                <div>
                                                    <div class="custom-14px-500 ml-2 mt-2 font-color-171717" @click="toggleSeniorityList">
    
    
                                                        <CRow class="mb-2">
                                                            <CCol sm="10">Seniority Level</CCol>
                                                            <CCol sm="2">
                                                                <span v-if="isTypeSeniorityListVisible"><img src="../assets/img/arrowup-black.png" style="max-width:20px"/></span>
                                                                <span v-else><img src="../assets/img/arrowdown-black.png" style="max-width:20px"/></span>
                                                            </CCol>
    
                                                        </CRow>
    
                                                    </div>
                                                    <div v-if="isCategorySeniorityVisible">
                                                        <CRow v-for="item in categoryJobSeniority" :key="item.Id" class="m-1">
                                                            <CCol sm="2">
                                                                <input type="checkbox" />
                                                            </CCol>
                                                            <CCol sm="10">
                                                                <label class="font-color-171717">{{ item.Category }}</label>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </div>

      <input type="range" class="custom-range mt-3" min="0" max="100" v-model="progressBarValue" @input="updateProgressBarWidth">
      <div class="d-flex justify-content-between mt-2">
        <span>Min Salary: ${{ minSalary }}</span>
        <span>Max Salary: ${{ maxSalary }}</span>
      </div>
                                                <br />  <br /> 
                                            </div>
    
    
                                    </CCol>
                                </CRow>
                            </div>
    
    
                        </div>
                    </CTab> -->
                </CTabs>
            </div>
        </div>
    
    
        <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Congratulations ! You have been placed in the Early Bord Candidate Benefit program, where you will be entitled to receive five free submissions once the feature becomes available.As an early bird, you're already ahead of the curve!
                    </h3>
                </div>
                <CButton class="button-border-202020" @click="closePopup2" block><span class="ml-2 mr-2">Close</span></CButton>
            </div>
        </div>
    
    
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

  import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },
  
    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            name: "",
            email: "",
            phone: "",
            password: "",
            selectedUser: "",


            isLanguagePopupVisible: false,
            emailinterest: "",

            selectedExpertise: "",
            selectedField: "",
            //selectedPosition: "",
            expertiseOptions: [], // Initialize as an empty array
            fieldOptions: [], // Initialize as an empty array
            positionOptions: [],
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            Names: "",
            activetab: "",
            isLoved: false, // Initial state
            filter: false,
            hideColumn: true,

            isCategoryListVisible: true, // Toggle state
            isTypeListVisible: false,
            isCategorySeniorityVisible: false,
            categoryJob: [],
            categoryJobType: [],
            categoryJobSeniority: [],
            isLoved: false, // Initial state
            progressBarValue: 50, // Initial value (percentage)
      minSalary: 50000,    // Example minimum salary
      maxSalary: 100000,   // Example maximum salary
      companyCode: false,
      codeCompany: '',
      ErrorCode: false,
      ShowCode: false,
      Message: "",
      result: {},
      selectedPosition: '',
      ErrorPosition: false,
      user: null,
      Names: "",
        };
        
    },
    created() {
        AOS.init();
      
    },

    mounted() {
        this.getListField();
        this.getListExpertise();
        this.getListPosition();
        this.GetListCategoryJob();
        this.GetListCategoryJobType();
        this.GetListCategoryJobSeniority();

       

   // if (window.location.hostname !== "www.interviewrr.ai") {
    //    window.location.href = "https://www.interviewrr.ai";
  //  }  
    },
    computed: {
        popupClass() {
            return this.activetab === 'Career' ? 'popup-all1' : 'popup-all2';
        },
        progressBarWidth() {
      return `${this.progressBarValue}%`; // Convert value to percentage for width
    },
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Index");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Index");
                console.error("Error fetching user info:", error);
            }
        },
       
        OpenFilter() {
           // this.filter = true;
           // this.hideColumn = false;

            this.filter = !this.filter;
            this.hideColumn = !this.hideColumn;
        
        },
        setActiveTab(tabName) {
            this.activetab = tabName;
        },

       
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            //  this.$router.push("HowItWork");
            this.isLanguagePopupVisible1 = true;
        },
        OpenHowItWork() {
            this.$router.push("HowItWork");
        },
        GoToLogin() {
            this.$router.push("Login");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup1() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup2() {
            this.isLanguagePopupVisible1 = false;
            this.isLanguagePopupVisible2 = false;
        },
        OpenPopup() {
            this.isLanguagePopupVisible = false;
            this.isLanguagePopupVisible1 = true;

        },
        SubmitData() {

            

            const formData = new FormData();

            formData.append("email", this.emailinterest);
            formData.append("experties", this.selectedExpertise.Name);
            formData.append("field", this.selectedField.Name);


            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.isLanguagePopupVisible1 = false;
                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenFormVideo() {
            if (!this.selectedPosition || !this.selectedPosition.Name) 
            {
                this.Message = 'Please select your current field';
                    this.ErrorPosition = true;
            }
            else
            {
                if(this.ErrorCode === true){
                    this.ErrorPosition = false;
                    this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)
                }
                else
                {
                    if(this.codeCompany === '')
                    {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)

                    }
                    else
                    {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name + "&code=" + this.codeCompany)
                    }
                   
                }
               
           
            }
        },
        async getListField() {
            try {
                const response = await this.$API.get(this.$GetListField);
                if (response.status === 200) {
                    this.fieldOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListExpertise() {
            try {
                const response = await this.$API.get(this.$GetListExpertise);
                if (response.status === 200) {
                    this.expertiseOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListPosition() {
            try {
                const response = await this.$API.get(this.$GetListPosition);
                if (response.status === 200) {
                    this.positionOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        OpenCalendly() {
            window.open("https://calendly.com/rasid-interviewrr");
        },
        toggleLove() {
            this.isLoved = !this.isLoved;
        },
        async GetListCategoryJob() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJob);
                if (response.status === 200) {
                    this.categoryJob = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleCategoryList() {
            this.isCategoryListVisible = !this.isCategoryListVisible;
        },

        async GetListCategoryJobType() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobType);
                if (response.status === 200) {
                    this.categoryJobType = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleTypeList() {
            this.isTypeListVisible = !this.isTypeListVisible;
        },

        async GetListCategoryJobSeniority() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobSeniority);
                if (response.status === 200) {
                    this.categoryJobSeniority = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleSeniorityList() {
            this.isCategorySeniorityVisible = !this.isCategorySeniorityVisible;
        },
        async VerifyCodeData() {
        try {
            this.ErrorPosition = false;
            const codeCompany1 = this.codeCompany;
            const response = await this.$API.get(this.$VerifyCode + '?code=' + codeCompany1); // Assuming this.$VerifyCode is your API endpoint URL
            
            if (response.status === 200) {
                this.result = response.data;
                if (this.result === 'The code is not ready for used.') {
                    this.Message = 'The code is not ready for used.';
                    this.ErrorCode = true;
                    
                } else if (this.result === 'The code is expired.') {
                    this.Message = 'The code is expired.';
                    this.ErrorCode = true;
                } else if (this.result === 'The code is invalid.') {
                    this.Message = 'The code is invalid.';
                    this.ErrorCode = true;
                } else {
                    this.Message = response.data
                    this.ShowCode = true;
                    this.ErrorCode = false;
                 
            }
            } else {
                // Handle non-200 status code
                console.error('Failed to fetch data:', response.statusText);
            }
        } catch (error) {
            // Handle the error here
            console.error('Error fetching data:', error);
        }
    }





    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

.overlay-text {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    left: 20px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    color: white;
    padding: 10px;
    text-align: center;
    font-size: 1.2em;
    /* Adjust as needed */
    width: 70%;
    margin: 0 auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height:90vh;
}
.salary-range {
  padding: 20px;
}

.progress {
  height: 20px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #007bff;
}

.custom-range {
  width: 100%;
}

.input-container {
  position: relative;
  display: inline-block;
  width:100%;
}

input[type="text"].custom {
  padding-right: 60px; /* Adjust according to button width */
  height:80px;
}

.verify-button {
  position: absolute;
  right: 2px;
  top: 3px;
  bottom:3px;
  height: 28px;
  border-radius: 50px;
  background: #928AFD;
  color:#fff;
  /* Optional: Adjust the button height to match the input field */
}
.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>